import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import mask from '@alpinejs/mask'

require('cleave.js/dist/addons/cleave-phone.fr');

window.Alpine = Alpine;

require('./functions/modal-supplement');
require('./functions/cross-sells');
require('./functions/fifty');
require('./functions/drink-dessert');
require('./functions/copy-promotions');

Alpine.plugin(collapse);
Alpine.plugin(mask);
Alpine.start();